import src from "./grid-icon.svg"

const width = 14
const height = 14
export default { src, width, height }